import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipuriProblemeComponent } from './tipuri-probleme.component';
import { AddTipuriProblemeComponent } from './add-tipuri-probleme/add-tipuri-probleme.component';
import { EditTipuriProblemeComponent } from './edit-tipuri-probleme/edit-tipuri-probleme.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        TipuriProblemeComponent,
        AddTipuriProblemeComponent,
        EditTipuriProblemeComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [TipuriProblemeComponent]
})
export class TipuriProblemeModule { }
